import { Component, OnDestroy, OnInit } from '@angular/core';

import { combineLatest, Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { LanguageCode } from '@language';
import {
    ApplicationConfigService,
    BaseContainer,
    DisclaimerConfig,
    DisclaimerContent,
    isNotNullOrUndefined,
    isString,
    ScrollspyNavItem
} from '@stylehaven/components';

@Component({
    selector: 'med-disclaimer-container',
    templateUrl: './disclaimer-container.component.html'
})
export class DisclaimerContainerComponent extends BaseContainer implements OnInit, OnDestroy {
    private disclaimerConfig$: Observable<DisclaimerConfig>;

    public disclaimerContent$: Observable<DisclaimerContent | null>;
    public scrollspyNavItems$: Observable<ScrollspyNavItem[]>;

    constructor(private readonly configService: ApplicationConfigService) {
        super();
    }

    ngOnInit(): void {
        this.initDisclaimerStreams();
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
    }

    private initDisclaimerStreams(): void {
        this.disclaimerConfig$ = this.configService.getConfig().pipe(
            map(config => config.disclaimerConfig),
            isNotNullOrUndefined(),
            take(1)
        );

        this.disclaimerContent$ = combineLatest([this.disclaimerConfig$, this.translateService.getDefaultLang()]).pipe(
            map(([config, defaultLang]) => this.getDisclaimerContent(config, defaultLang.Language))
        );

        this.scrollspyNavItems$ = this.disclaimerContent$.pipe(
            map(content => content?.sections.map(section => section.sectionTitle)),
            isNotNullOrUndefined(),
            map(sectionTitles => sectionTitles.filter(isString)),
            map(sectionTitles =>
                sectionTitles.map(title => ({
                    label: title,
                    target: title
                }))
            )
        );
    }

    private getDisclaimerContent(config: DisclaimerConfig, defaultLang: LanguageCode): DisclaimerContent | null {
        const currentLang: LanguageCode = this.translateService.getCurrentLanguage();
        const fullContent: DisclaimerContent | null = config.fullContent
            ? (config.fullContent[currentLang] ?? config.fullContent[defaultLang])
            : null;

        if (!fullContent) {
            console.error('No disclaimer translation found');
        }

        return fullContent;
    }
}
